module.exports = __webpack_public_path__ + "static/media/information-icon.7e797f10.png";